<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';

    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        className?: HTMLAttributes['class'];
    }

    defineProps<Props>();
</script>

<template>
    <svg
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="className"
    >
        <path
            d="M2.87039 0.853516H0.857422V15.2452H4.33983V11.2192H4.64199C4.90341 11.2192 5.28582 11.2192 5.46699 11.5615L7.06119 14.4603C7.40285 15.1242 7.80531 15.2452 8.55007 15.2452H11.1874L8.84847 10.6356C8.48613 9.9316 8.0636 9.77049 8.0636 9.77049V9.73037C8.0636 9.73037 8.446 9.52851 8.82841 8.86463L11.183 4.87945H7.39909L5.70834 7.97882C5.52717 8.30105 5.18489 8.30105 4.88335 8.30105H4.33983V2.0208C4.33983 0.994569 3.89662 0.853516 2.87039 0.853516Z"
            fill="#39A8E2"
        />
    </svg>
</template>
